export const initialFetches = {
  proposals: { needFetch: true, isFetching: false },
  bids: { needFetch: true, isFetching: false },
};
export const initialSelectedTour = {
  id: null,
  selectedEvent: null,
  tour: {},
  bidFilter: { DR: true }, // Default filter options
  eventFilter: {},
  fetches: initialFetches,
  isFetching: false,
  needFetch: true,
  hasError: false,
  proposals: [],
  bids: [],
  messages: [],
  bid_id: 0,
};
export const initialState = {
  tours: [],
  tourStateFilter: { AR: true }, // Default to filter archived tours
  tourManagerSim: false,
  isFetching: false,
  needFetch: true,
  brands: [], // list of brands to use in search
  places: [], // list of places to use in search
  hotels: {}, // Hotel dict by event id
  fetchingHotels: {}, // Hotel dict by event id
  findHotels: { hotels: [], fetching: false, search: null },
  selectedTour: initialSelectedTour,
  tourManagers: [],
  bidbidsDetails: [],
  compareBids: [],
  brandGroups: [],
};



// WEBPACK FOOTER //
// src/routes/tours/modules/initialState.js